import { crudService } from '../_services'
import { stringUtils } from 'utils'
import { toast } from 'react-toastify'

export const notificacaoUsuarioAction = {
  getNotificacaoUsuario,
  addNotificacaoUsuario,
  getNotificacaoUsuarioById,
  getNotificacoesByCliente,
  onChangeProps,
  /*editNotificacaoUsuarioInfo,*/
  editNotificacaoUsuariosDetails,
  createNotificacaoUsuario,
  deleteNotificacaoUsuarioById,
  clear,
  clearAll,
  clearInfo
}

function getNotificacaoUsuario(filterModel, showWaiting) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'notificacoesUsuarios' + stringUtils.serialize(filterModel);
    crudService
      .get(apiEndpoint)
      .then((response) => {
        dispatch(changeNotificacaoUsuariosList(response.data.items, response.data.totalRows))
        dispatch(notIsLoading())
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

function getNotificacoesByCliente(filterModel, showWaiting) {
  return (dispatch) => {
    let apiEndpoint = 'notificacoesUsuarios/cliente' + stringUtils.serialize(filterModel);
    crudService
      .get(apiEndpoint)
      .then((response) => {
        dispatch(changeNotificacaoUsuariosList(response.data.items, response.data.totalRows))
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

function createNotificacaoUsuario(payload) {
  return (dispatch) => {
    let apiEndpoint = 'notificacoesUsuarios/'
    crudService.post(apiEndpoint, payload).then(() => {
      dispatch(createNotificacaoUsuarioInfo())
      toast.success('Feito! Cadastro realizado com sucesso! 😎')

      let filterModel = {
        Page: 1,
        Limit: 10,
        Term: '',
        IdNotificacao: payload.idNotificacao
      };
      dispatch(getNotificacaoUsuario(filterModel, false))


    })
  }
}

function getNotificacaoUsuarioById(id) {
  return (dispatch) => {
    let apiEndpoint = 'notificacoesUsuarios/' + id
    crudService.get(apiEndpoint).then((response) => {
     // console.log('response.data', response.data)
      dispatch(editNotificacaoUsuariosDetails(response.data))
    })
  }
}

function onChangeProps(props, event) {
  return (dispatch) => {
    if (event.target.type === 'checkbox') {
      dispatch(handleOnChangeProps(props, event.target.checked))
    } else {
      dispatch(handleOnChangeProps(props, event.target.value))
    }
  }
}

//function editNotificacaoUsuarioInfo(id, payload, redirect) {
//  return (dispatch) => {
//    let apiEndpoint = 'notificacoesUsuarios/' + id
//    crudService.put(apiEndpoint, payload).then(() => {
//      dispatch(updatedNotificacaoUsuarioInfo())
//      dispatch(clear())
//      if (redirect) {
//        history.push('/notificacoesUsuarios')
//      }
//    })
//  }
//}

function deleteNotificacaoUsuarioById(id) {
  return (dispatch) => {
    let apiEndpoint = 'notificacoesUsuarios/' + id
    crudService.deleteDetail(apiEndpoint).then((response) => {
      var ret = JSON.parse(response.request.responseText);
      dispatch(deleteNotificacaoUsuariosDetails())

      let filterModel = {
        Page: 1,
        Limit: 10,
        Term: '',
        IdNotificacao: ret.key
      };
      dispatch(getNotificacaoUsuario(filterModel, false))

    })
  }
}

export function addNotificacaoUsuario(payload) {
  return [{ type: 'ADD_NOTIFICACAO_USUARIO', notificacaoUsuario: payload }, clear()]
}

export function changeNotificacaoUsuariosList(notificacaoUsuario, totalRows) {
  return {
    type: 'FETCHED_ALL_NOTIFICACAO_USUARIO',
    notificacaoUsuario: notificacaoUsuario,
    totalRegistros: totalRows
  }
}

export function clear() {
  return {
    type: 'NOTIFICACAO_USUARIO_CLEAR'
  }
}

export function clearAll() {
  return {
    type: 'NOTIFICACAO_USUARIO_CLEAR_ALL'
  }
}

export function clearInfo() {
  return {
    type: 'NOTIFICACAO_USUARIO_CLEAR_INFO'
  }
}

export function handleOnChangeProps(props, value) {
  return {
    type: 'NOTIFICACAO_USUARIO_HANDLE_ON_CHANGE',
    props: props,
    value: value
  }
}

export function editNotificacaoUsuariosDetails(notificacaoUsuario) {
  return [
    { type: 'NOTIFICACAO_USUARIO_DETAIL', notificacaoUsuario },
  ]
}

export function updatedNotificacaoUsuarioInfo() {
  return {
    type: 'NOTIFICACAO_USUARIO_UPDATED'
  }
}

export function createNotificacaoUsuarioInfo() {
  return {
    type: 'NOTIFICACAO_USUARIO_CREATED_SUCCESSFULLY'
  }
}

export function deleteNotificacaoUsuariosDetails() {
  return {
    type: 'DELETED_NOTIFICACAO_USUARIO_DETAILS'
  }
}

export function isLoading() {
  return {
    type: 'NOTIFICACAO_USUARIO_ISLOADING'
  }
}

export function notIsLoading() {
  return {
    type: 'NOTIFICACAO_USUARIO_NOTISLOADING'
  }
}
